import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import { withNamespaces } from "react-i18next";
import { ShieldUser, User } from "lucide-react";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import AppRentalHeader from '../containers/AppRentalHeader'
import { putUpdatePrerental } from '../actions/qrsrental'
import StepBarRental from '../components/StepBarRental'

class PhoneRentalView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      phoneNumber: '',
      mail: '',
      zona: '1',
      accesible: 'NO',
      confirmReservation: false,
      newsletterAcceptance: false,
      qrsale: null,
      booking: null,
      lockerSelected: null,
      descriptionZone: null,
      selectedAccessibility: null,
      zoneSelected: null,
      selectedLocker: null,
      lockerAssigned: null,
      lockerPrice: null,
      paymentId: null,
      qrToken: null,
      lockerPin: null,
      lockerMatricula: null,
      lockerCustomer: null,
      lockerInvoice: null,
      qrType: "pay",
      qrMode: 0,
      customerName: '',
      language: null,
      startDate: null,
      endDate: null,
      terms: ''
    }

    this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
    this.handleMailChange = this.handleMailChange.bind(this);
    this.handleCustomerNameChange = this.handleCustomerNameChange.bind(this);
  }

  handlePhoneNumberChange(value, countryData) {
    let cleaned = value;

    if (countryData && countryData.dialCode) {
      const dc = countryData.dialCode;
      cleaned = cleaned.replace(/^\+/, '');

      if (cleaned.startsWith(dc) && cleaned.slice(dc.length).startsWith(dc)) {
        cleaned = cleaned.slice(dc.length);
      }

      const afterDc = cleaned.slice(dc.length);
      if (afterDc.startsWith('00' + dc)) {
        cleaned = dc + afterDc.slice(('00' + dc).length);
      }

      cleaned = cleaned.replace(/[^\d]/g, '');
    }

    this.setState({ phoneNumber: cleaned });
  }

  // Utility function to remove accents
  removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  // Updated method
  handleCustomerNameChange(event) {
    const customerName = this.removeAccents(event.target.value);
    this.setState({ customerName });
  }

  handleMailChange(event) {
    const mail = event.target.value;
    const isValidEmail = this.validateEmail(mail);
    this.setState({ mail, isValidEmail });
  }

  validateEmail(email) {
    // A simple email validation pattern using regular expression
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  goTo(e) {
    const {
      zoneSelected,
      descriptionZone,
      selectedLocker,
      lockerPrice,
      lockerAssigned,
      prerentCode,
      prerentTime,
      totalDays,
      startDate,
      endDate,
      qrType,
      qr,
      timeStamp,
      customerId
    } = this.props.location.state;

    if (!this.isContinueDisabled()) {

      this.props.putUpdatePrerental(prerentCode, {
        PrerentName: this.state.customerName,
        PrerentPhone: this.state.phoneNumber,
        PrerentEmail: this.state.mail,
      });

      this.props.push('/PaymentRentalView', {
        // PASSED VARS
        zoneSelected: zoneSelected,
        descriptionZone: descriptionZone,
        selectedLocker: selectedLocker,
        lockerPrice: lockerPrice,
        lockerAssigned: lockerAssigned,
        prerentCode: prerentCode,
        prerentTime: prerentTime,
        totalDays: totalDays,
        startDate: startDate,
        endDate: endDate,
        qrType: qrType,
        qr: qr,
        timeStamp: timeStamp,
        customerId: customerId,
        // PHONE VARS
        customerName: this.state.customerName,
        phoneNumber: this.state.phoneNumber,
        mail: this.state.mail,
        newsletterAcceptance: this.state.newsletterAcceptance,
        confirmReservation: this.state.confirmReservation,
      });
    }
  }

  componentDidMount() {

  }

  isContinueDisabled() {

    const disabled = ((this.state.phoneNumber.length < 6) || !this.state.isValidEmail || !this.state.confirmReservation || this.state.customerName.length == 0);

    return disabled;
  }

  getButtonStyle() {
    const { qrData } = this.props;
    const buttonColor1 = qrData?.headerConfig?.buttonColor1 || '#01315f';
    const buttonColor2 = qrData?.headerConfig?.buttonColor2 || '#067ddb';
    const buttonText = qrData?.headerConfig?.buttonText || '#ffffff';
    
    return {
      background: `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`,
      color: buttonText,
      border: 'none'
    };
  }

  getIconColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.iconsColor || '#01315f';
  }

  render() {
    const { t, i18n } = this.props;
    const { terms } = this.props.location.state;
    const { invalidPhone, isButtonDisabled } = this.state;

    const iconsColor = this.getIconColor();
    const buttonStyle = isButtonDisabled ? {} : this.getButtonStyle();


    return (
      <div className="rentalBackground">
        <AppRentalHeader />
        <div className="lockerContainer smartphone">
          <br></br>
          <h3 className="lockTitle">
            <span className="text-vw-dark">{t('DATOS DE RESPALDO')}</span>
          </h3>
          <div className="unified-form">
            <ShieldUser className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />

            <div className="lockTitle">
              <span className="text-vw-semidark">{t('Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin')}</span>
            </div>

            {/* NAME */}
            <div className="mt-2 rental-uf-row">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t('Nombre Completo*')}</span>
                <input className="rental-phoneInput"
                  name="name"
                  type="text"
                  value={this.state.customerName}
                  onChange={this.handleCustomerNameChange}
                  placeholder={t('Introduce tu nombre')}
                />
              </div>
            </div>

            {/* EMAIL */}
            <div className="rental-uf-row">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t('Email*')}</span>
                <input className="rental-phoneInput"
                  name="lockerEmail"
                  type="text"
                  value={this.state.mail}
                  onChange={this.handleMailChange}
                  autoCapitalize='none'
                  placeholder={t('Introduce tu email')}
                />
              </div>
            </div>

            {/* PHONE */}
            <div className="rental-uf-row">
              <div className="rental-uf-btn">
                <span className="rental-uf-label">{t('Teléfono*')}</span>
                <PhoneInput
                  country="es" // default country code
                  value={this.state.phoneNumber}
                  onChange={this.handlePhoneNumberChange}
                  inputClass="rental-phoneInput" // style to match form
                  pattern="[0-9]*"
                  placeholder={t('Introduce tu teléfono')}
                  countryCodeEditable={false}
                />
              </div>
            </div>

            {/* CHECKBOX */}
            <div className='divCheckbox'>
              <input
                type="checkbox"
                id="confirmReservation"
                name="confirmReservation"
                checked={this.state.confirmReservation}
                onChange={() => this.setState({ confirmReservation: !this.state.confirmReservation })}
              />
              <div className="rental-slider"></div>
              <label htmlFor="confirmReservation" className='rental-slide-checkbox'>
                {t('Confirmo que he leído y acepto los')} <a
                  href={terms}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="terms-link"
                >
                  {t('términos y condiciones')}
                </a>
              </label>
            </div>
            <div
              className={`col lockerPhoneButton ${this.isContinueDisabled() ? "disabled" : ""}`}
              style={!this.isContinueDisabled() ? buttonStyle : {}}
              onClick={(e) => this.goTo(1, e)}
            >
              {t("Continuar")}
            </div>
            <div className="mt-2 w-100 text-center">
              <span className="text-vw-semidark rental-phone-advert">{t('*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo si el cliente no se suscribe a la newsletter.')}</span>
            </div>
          </div>
          <br></br>
          <StepBarRental step={3} />
        </div>

        <div className="lockerContainer pc">
          <h3 className="lockTitle">
            <span className="text-vw-dark">{t('DATOS DE RESPALDO')}</span>
          </h3>
          <div className="lockTitle">
            <span className="text-vw-semidark">{t('Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin de esta en caso de que lo pierdas. Al email te llegará la confirmación de tu reserva.')}</span>
          </div>
          <div className="rental-phoneForm">
            <div className="row">
              <div className="col-6">
                <span className="rental-uf-label">{t('Nombre Completo*')}</span>
                <input className="rental-emailInput"
                  name="name"
                  type="text"
                  value={this.state.customerName}
                  onChange={this.handleCustomerNameChange}
                />
                <br></br>
                <span className="rental-uf-label">{t('Email*')}</span>
                <input className="rental-emailInput"
                  name="lockerEmail"
                  type="text"
                  value={this.state.mail}
                  onChange={this.handleMailChange}
                  autoCapitalize='none'
                />
                <br></br>
                <span className="rental-uf-label">{t('Teléfono*')}</span>
                <div className="mt-2"></div>
                <PhoneInput
                  country="es" // default country code
                  value={this.state.phoneNumber}
                  onChange={this.handlePhoneNumberChange}
                  inputClass="rental-phoneInput" // style to match form
                  pattern="[0-9]*"
                  countryCodeEditable={false}
                />
              </div>
              <div className="col-1">

              </div>
              <div className="col-5">
                <ShieldUser className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />
                <div className='divCheckbox'>
                  <input
                    type="checkbox"
                    id="confirmReservation"
                    name="confirmReservation"
                    checked={this.state.confirmReservation}
                    onChange={() => this.setState({ confirmReservation: !this.state.confirmReservation })}
                  />
                  <div className="rental-slider"></div>
                  <label htmlFor="confirmReservation" className='rental-slide-checkbox'>
                    {t('Confirmo que he leído y acepto los')} <a
                      href={terms}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="terms-link"
                    >
                      {t('términos y condiciones')}
                    </a>
                  </label>
                </div>
                <div
                  className={`col lockerPhoneButton ${this.isContinueDisabled() ? "disabled" : ""}`}
                  style={!this.isContinueDisabled() ? buttonStyle : {}}
                  onClick={(e) => this.goTo(1, e)}
                >
                  {t("Continuar")}
                </div>
              </div>
            </div>
            <div className="row w-100 text-center">
              <div className="mt-5 w-100 text-center">
                <span className="text-vw-semidark rental-phone-advert">{t('*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo si el cliente no se suscribe a la newsletter.')}</span>
              </div>
            </div>
          </div>
          <br></br>
          <StepBarRental step={3} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: true,
  qrData: state.qrs.qr,
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  putUpdatePrerental: bindActionCreators(putUpdatePrerental, dispatch)
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(PhoneRentalView));
